import { useCompetitions } from '@/features/league/queries'
import styles from './CompetitionPicker.module.css'

type CompetitionPickerProps = {
  value:    string | null
  onChange: (id: string) => void
}

export function CompetitionPicker({ value, onChange }: CompetitionPickerProps) {
  const { data: competitions, isPending, isError } = useCompetitions()

  if (isPending) return <div className={styles.label}>Carregando competições…</div>
  if (isError || !competitions) return <div className={styles.label}>Erro ao carregar competições.</div>

  return (
    <label className={styles.wrap}>
      <span className={styles.label}>Competição</span>
      <select
        className={styles.select}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="" disabled>Selecione…</option>
        {competitions.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  )
}
